var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.$t("fillInAddressInformation"),
      rightMethod: _vm.onSubmitted,
      medium: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-flex",
              { attrs: { md5: "" } },
              [
                _c("v-text-field", {
                  staticClass: "required_field",
                  attrs: {
                    label: _vm.$t("site_name"),
                    id: "Sitename",
                    disabled: _vm.editMode && !_vm.siteKeyCanEdit,
                    rules: [
                      _vm.fieldIsRequired("Site name"),
                      _vm.checkDupSiteName
                    ]
                  },
                  model: {
                    value: _vm.site.siteName,
                    callback: function($$v) {
                      _vm.$set(_vm.site, "siteName", $$v)
                    },
                    expression: "site.siteName"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("v-text-field", {
              staticClass: "required_field",
              attrs: {
                label: _vm.$t("addressLine1"),
                id: "Address",
                rules: [_vm.fieldIsRequired("Address")]
              },
              model: {
                value: _vm.site.address1,
                callback: function($$v) {
                  _vm.$set(_vm.site, "address1", $$v)
                },
                expression: "site.address1"
              }
            }),
            _vm._v(" "),
            _c("v-text-field", {
              attrs: { label: _vm.$t("addressLine2"), id: "Address2" },
              model: {
                value: _vm.site.address2,
                callback: function($$v) {
                  _vm.$set(_vm.site, "address2", $$v)
                },
                expression: "site.address2"
              }
            }),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { "justify-space-between": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: {
                        label: _vm.$t("city"),
                        id: "City",
                        rules: [_vm.fieldIsRequired("City")]
                      },
                      model: {
                        value: _vm.site.city,
                        callback: function($$v) {
                          _vm.$set(_vm.site, "city", $$v)
                        },
                        expression: "site.city"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        items: _vm.states,
                        label: _vm.$t("state"),
                        disabled: _vm.editMode && !_vm.siteKeyCanEdit,
                        id: "addressState"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item",
                          fn: function(data) {
                            return [
                              [
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c(
                                      "v-list-tile-title",
                                      { attrs: { id: data.item } },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(data.item) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.site.state,
                        callback: function($$v) {
                          _vm.$set(_vm.site, "state", $$v)
                        },
                        expression: "site.state"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: {
                        label: _vm.$t("zipCode"),
                        id: "Zip code",
                        disabled: _vm.editMode && !_vm.siteKeyCanEdit,
                        rules: [
                          _vm.fieldIsRequired("Zip code"),
                          _vm.fieldIsZip("Zip code")
                        ]
                      },
                      model: {
                        value: _vm.site.zip,
                        callback: function($$v) {
                          _vm.$set(_vm.site, "zip", $$v)
                        },
                        expression: "site.zip"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { "justify-space-between": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { md5: "" } },
                  [
                    _vm.isWarehouse
                      ? _c("v-text-field", {
                          attrs: { label: _vm.$t("contact"), id: "Contact" },
                          model: {
                            value: _vm.site.contact,
                            callback: function($$v) {
                              _vm.$set(_vm.site, "contact", $$v)
                            },
                            expression: "site.contact"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md5: "" } },
                  [
                    _vm.isWarehouse
                      ? _c("v-text-field", {
                          attrs: { label: _vm.$t("phone"), id: "Phone" },
                          model: {
                            value: _vm.site.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.site, "phone", $$v)
                            },
                            expression: "site.phone"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              [
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-switch", {
                      attrs: { label: _vm.$t("stopReceive") },
                      model: {
                        value: _vm.site.stopReceive,
                        callback: function($$v) {
                          _vm.$set(_vm.site, "stopReceive", $$v)
                        },
                        expression: "site.stopReceive"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0201af8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0201af8a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditAddress.vue
// module id = null
// module chunks = 